import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { closeFailedPasswordChangeModalError } from 'actions';

import ModalWrapper from '../ModalWrapper';
import PasswordChangeForm from './PasswordChangeForm';

class PasswordChangeModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isShown: PropTypes.bool.isRequired,
    onConfirmUpdate: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    changePasswordError: PropTypes.shape({
      code: PropTypes.number,
      message: PropTypes.string
    })
  };

  static defaultProps = {
    changePasswordError: null
  };

  hideError() {
    const { dispatch } = this.props;
    dispatch(closeFailedPasswordChangeModalError());
  }

  render() {
    const {
      isShown,
      onCancel,
      onConfirmUpdate,
      changePasswordError
    } = this.props;
    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Change Password"
        btnConfirmTitle="Confirm"
        btnCancelTitle="Cancel"
        onCancel={ onCancel }
        formId="pwdChgForm"
      >
        <p>
          Please enter and confirm a new password
        </p>

        <div>
          <PasswordChangeForm
            id="pwdChgForm"
            onSubmit={ onConfirmUpdate }
          />
          { changePasswordError && changePasswordError.code !== 0 && <div className="toast toast-error">
            <button type="button" onClick={ () => this.hideError() } className="btn btn-clear float-right" />
            { changePasswordError.message }
          </div>}
        </div>
      </ModalWrapper>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      changePasswordError
    }
  } = state;

  return {
    changePasswordError
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordChangeModal);
